export default __webpack_public_path__ + "static/20-a76e4d7313a579ec5f91000dc43e9a33.png";